module.exports = __webpack_public_path__ + "static/media/front render 1.a0de1224.jpg";